export enum PartnerTypes {
  visitor = "visitor",
  certified = "certified",
  preferred = "preferred",
  exclusive = "exclusive",
}

export default interface ITier {
  type: PartnerTypes;
  name: string;
  description: string;
}
